import React from "react";
import styled from "styled-components";

import { colors, device, fonts, fontWeights } from "../App/StyleVariables";
import { ReactComponent as SnapIcon } from "./icon-snap.svg";
import { BlankLink } from "../Shared";

const SuccessWrap = styled.div`
  background: ${colors.white};
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.4) 0px 4px 10px 4px;
  color: ${colors.darkBlue};
  display: ${props => (props.isHidden ? "none" : "block")};
  margin: 0 auto;
  padding: 2rem 1rem;
  text-align: center;

  @media ${device.md} {
    width: 52%;
    max-width: 30rem;
  }
`;

const SuccessHeadline = styled.h2`
  font-family: ${fonts.brandon};
  font-size: 1.75rem;
  font-weight: ${fontWeights.bold};
  letter-spacing: 0.0625rem;
  line-height: 2.5rem;
  margin-bottom: 1rem;
`;

const SuccessParagraph = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;

  a,
  a:hover,
  a:visited {
    color: inherit;
  }
`;

const MainSuccess = ({ isHidden }) => (
  <SuccessWrap isHidden={isHidden}>
    <SnapIcon alt="fingers snap icon" />
    <SuccessHeadline children="Thank you for your interest." />
    <SuccessParagraph>
      We'll let you know when we're available in your country. In the meantime,
      visit our site for the{" "}
      <BlankLink href="https://www.harrys.com/en/gb?sticky=true">UK</BlankLink>,{" "}
      <BlankLink href="https://www.harrys.com/en/ca?sticky=true">
        Canada
      </BlankLink>
      , or the{" "}
      <BlankLink href="https://www.harrys.com/en/us?sticky=true">US</BlankLink>.
    </SuccessParagraph>
  </SuccessWrap>
);

export default MainSuccess;
